import { render } from "./service_applications.html?vue&type=template&id=b990d556&external"
import script from "./service_applications.js?vue&type=script&lang=js&external"
export * from "./service_applications.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__